import { EventColor } from 'calendar-utils';
import { CalAndNewsFileInfo, MyFile } from './fileInfo';


export class PortalEvent {

	id = "";
	tmsStart: number | null = null;
	tmsEnd: number | null = null;
	tmsRegisterUntil: number | null = null;
	tmsReminderMail: number | null = null;
	place = "";
	name = "";
	description = "";
	groups: string[] = [];
	bReleased = false;
	bReminderMailSent = false;

	files: MyFile[] = [];

	assignedUsers: { ebeId: string, vbAngemeldet: boolean }[] = [];

	categoryId = "";
	visibility = "nein";
	nurIntern = false;

}


export class PortalEventBackend {

	veranstaltungId = "";
	veranstaltungAnfangsDatum: number | null = 0;
	veranstaltungEndDatum: number | null = 0;
	veranstaltungOrt = "";
	veranstaltungName = "";
	veranstaltungsBeschreibung = "";
	gruppen: string[] = [];
	veranstaltungErinnerungsmail: number | null = 0;
	veranstaltungErinnerungsmailGesendet: boolean | null = null;
	veranstaltungFreigeben = false;

	dateien: CalAndNewsFileInfo[] = [];

	assignedBenutzer: { ebeId: string, vbAngemeldet: boolean }[] = [];

	veranstaltungAnmeldungsFrist: number | null = 0;

	fragenKategorieId = "";
	nurIntern= false;

}


export const calendarColors: Record<string, EventColor> = {
	red: {
		primary: '#ad2121',
		secondary: '#FAE3E3',
	},
	blue: {
		primary: 'var(--mainColor)',
		secondary: 'darkblue',
	},
	yellow: {
		primary: '#e3bc08',
		secondary: '#FDF1BA',
	},
	grey: {
		primary: 'lightgrey',
		secondary: 'darkgrey',
	},
};


export class CalendarGroup {

	vgId = "";
	vgName = "";
	vgAktiv = true;
	// veranstaltungen: PortalEventBackend[] = [];
	arbeitsgruppe = false;
	vgChat = false;

}

export class EventCategory {
	fkBezeichnung = "";
	fkId = "";
}
